export default "__VITE_ASSET__CfwJBXf___"